import { Linkedin } from "lucide-react";
import { Reveal } from "./Reveal";

const FOUNDERS = [
  {
    name: "Prinkan Pal",
    role: "Co-founder & CEO",
    linkedin: "https://www.linkedin.com/in/prinkan/",
    photo: "https://customer-assets-rejwkqb3.emergentagent.net/job_intugle-ai-platform/artifacts/66oculb8_Prinkan_web.png",
    bio: "An AI and analytics leader with a proven track record of delivering high-impact enterprise solutions. At Intugle, Prinkan specializes in building and scaling data-driven products that transform complex business challenges into scalable, contextually intelligent AI applications.",
  },
  {
    name: "Manan Pachnanda",
    role: "Co-founder & CPO",
    linkedin: "https://www.linkedin.com/in/manan-pachnanda-09a73356/",
    photo: "https://customer-assets-rejwkqb3.emergentagent.net/job_intugle-ai-platform/artifacts/4m07zacz_Manan_web.png",
    bio: "A strategy and AI leader with over 12 years of experience driving business transformation for Fortune 500 organizations. At Intugle, Manan works at the intersection of enterprise strategy, data engineering, semantic intelligence, and agentic AI to deliver scalable business outcomes.",
  },
  {
    name: "Jaskaran Singh",
    role: "Co-founder & CTO",
    linkedin: "https://www.linkedin.com/in/jaskaran-singh-879192a1/",
    photo: "https://customer-assets-rejwkqb3.emergentagent.net/job_intugle-ai-platform/artifacts/s9rp9y6a_Jaskaran_web.png",
    bio: "An AI and data science leader with extensive experience in ML, natural language processing, and enterprise intelligence. At Intugle, Jaskaran focuses on building context-aware AI systems that help organizations transform complex enterprise data into scalable AI solutions.",
  },
];

export const Leadership = () => (
  <section id="leadership" className="relative z-[91] bg-[#211307] text-[#F7F5F0] py-14 lg:py-16" data-testid="leadership-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-8">
      <Reveal delay={0.02}><p className="font-mono2 text-[11px] uppercase tracking-[0.28em] text-[#EDA13A] mb-4">Leadership</p></Reveal>
      <Reveal delay={0.04}><h2 className="font-display font-medium tracking-tight text-2xl sm:text-3xl lg:text-[2.5rem] leading-[1.12] max-w-4xl">Meet the Founders</h2></Reveal>

      <div className="mt-8 grid md:grid-cols-3 gap-8">
        {FOUNDERS.map((f, i) => (
          <Reveal key={f.name} delay={0.08 + i * 0.08}>
            <div className="flex flex-col w-full max-w-[250px]" data-testid={`founder-card-${i}`}>
              <div className="w-full aspect-[4/5] rounded-2xl bg-black overflow-hidden">
                <img src={f.photo} alt={f.name} loading="lazy" className="w-full h-full object-cover object-top" />
              </div>
              <h3 className="mt-6 font-display text-xl font-medium">{f.name}</h3>
              <p className="mt-1 font-mono2 text-[11px] uppercase tracking-[0.16em] text-[#EDA13A]">{f.role}</p>
              <p className="mt-4 text-[13px] text-white/60 leading-relaxed">{f.bio}</p>
              <a
                href={f.linkedin}
                target="_blank"
                rel="noreferrer"
                data-testid={`founder-linkedin-${i}`}
                className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-white/80 hover:text-[#EDA13A] transition-colors"
              >
                <Linkedin size={16} /> Connect
              </a>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
